import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { tap } from 'rxjs';
import { maxDateValidator } from 'src/app/shared/form-validators/date-validators';

interface IPhoenixTableDateInputForm {
  date: FormControl<string>;
}

@Component({
  selector: 'app-phoenix-table-date-input',
  templateUrl: './phoenix-table-date-input.component.html',
  styleUrl: './phoenix-table-date-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoenixTableDateInputComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  
  readonly maxDateString_ = input.required<string>();
  readonly maxDateJsDate_ = computed(() => new Date(this.maxDateString_()));
  
  dateChanged = output<string>();
  dateError = output<string>();

  private _fb = inject(FormBuilder);
  
  protected form: FormGroup<IPhoenixTableDateInputForm>;

  ngOnInit(): void {
    this.form = this._fb.group({
      date: ['', maxDateValidator(this.maxDateJsDate_())]
    });

    this.form.get('date').valueChanges
      .pipe(
        tap((val) => this.dateChanged.emit(val)),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }

  protected isMaxDateExceeded(): boolean {
    const hasError = this.form.get('date').hasError('maxDateExceeded');
    
    this._handleError(hasError, 'maxDateExceeded');

    return hasError;
  }

  private _handleError(hasError: boolean, errorName: string): void {
    if (hasError) {
      this.dateError.emit(errorName);
    } else {
      this.dateError.emit(null);
    }
  }
}
